/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box
} from "@mui/material";
import { useState, useEffect } from "react";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";

//
// ###########################################################################
//
const DatosAnteojoSol = ({ articulo, showPrecio = true }) => {
  const [colores, setColores] = useState("");

  //
  // ################################################################################
  //
  useEffect(() => {

    const coloresList = articulo.articulo_color
      .map(c => c.descripcion_ar_as_color)
      .join(", ");

    setColores(coloresList);
  }, [articulo]);
  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Anteojo de sol
              </Typography>

              <Grid container spacing={2}>
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Marca" value={articulo.descripcion_ar_as_marca} />
                <Item label="Modelo" value={articulo.modelo} />
                <Item label="Tipo" value={articulo.descripcion_ar_as_tipo} />
                <Item label="Categoría" value={articulo.descripcion_ar_as_categoria} />
                <Item label="Formato" value={articulo.descripcion_ar_as_formato} />
                <Item label="Material" value={articulo.descripcion_ar_as_material} />
                <Item label="Color de lente" value={articulo.descripcion_as_color_lente} />
                <Item label="Color de la montura" value={colores} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosAnteojoSol;
